import { ProRoutes, proQueryParams } from '../routes';
import { useRouteParams } from '@medely/ui-kit';

export const useProRouteParams = <K extends keyof ProRoutes>(path: K): { params: ProRoutes[K] } => {
  const params = useRouteParams<ProRoutes, K>(path, proQueryParams);
  return params;
};
